import styled from 'styled-components';
export const ButtonDesktopContainer = styled.div.withConfig({ displayName: "ButtonDesktopContainer", componentId: "sc-sgr9b0" }) `
  margin-left: auto; 
  margin-right: 10px;
  min-width: 200px;
  display: flex;
  flex-direction: row-reverse;
`;
export const ButtonMobileContainer = styled.div.withConfig({ displayName: "ButtonMobileContainer", componentId: "sc-arwggs" }) `
  margin: 20px 0 0 0;
  button {
    width 100%;
  }
`;
export const CollapsableContainer = styled.div.withConfig({ displayName: "CollapsableContainer", componentId: "sc-1axk6jc" }) `
  display: block;
  flex-direction: column;
  flex-wrap: wrap;
`;
export const TextContainer = styled.div.withConfig({ displayName: "TextContainer", componentId: "sc-3apv4c" }) `
  margin-right: 30px;
`;
export const RowContainer = styled.div.withConfig({ displayName: "RowContainer", componentId: "sc-1f750pr" }) `
  display: flex;
`;
export const IconContainer = styled.div.withConfig({ displayName: "IconContainer", componentId: "sc-1g1ufe8" }) `
  width: 40px;
  margin-right: 20px;
`;
export const getButtonContainer = (isMobile) => isMobile ? ButtonMobileContainer : ButtonDesktopContainer;
export const getInstructionContainer = (isMobile) => isMobile ? CollapsableContainer : RowContainer;
export const getInstructionTextContainer = (isMobile) => isMobile ? styled.div `` : TextContainer;
